import React, {useState} from 'react'
import Spinner from '../reusables/spinner';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import {approve_supplier, verify_customer} from '../../redux/actions/adminActions';

function ApproveModal({ show, handleClose, users, customer, verify, approve, accessToken}) {

    const [isLoading,
        setIsLoading] = useState(false)

    const handleLoading = () => {
        setIsLoading(true);

        setTimeout(() => setIsLoading(false), 5000)
    }

    const handleApprove = id => {
        handleLoading();
        if(customer){
            verify(id, accessToken, handleClose)
        }else{
            approve(id, accessToken, handleClose);
        }
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="icon--tiny isClickable closeModal" onClick={handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="sectionHeight--mid center">
                <div className="w-100 vAlign">
                    <h2 className="sectionText--mid">Are you sure you want to { customer ? 'verify' : 'approve'} { ' ' } { users?.length > 1 ? 'these' : 'this' } { ' ' } user{ users?.length > 1 && 's' }?</h2>

                    <div className="pt-3 center">
                        {isLoading
                            ? <div className='center'>
                                    <Spinner dark/>
                                </div>
                            : <div>
                                <button className="btn__filled mx-2 hasRadius">No, Cancel</button>
                                < button className="btn__transparent" onClick={ () => handleApprove(users) }>
                                    Yes, {' '} {customer ? 'Verify' : 'Approve'}
                                </button>
                            </div>
}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    approve: (id, token, success) => dispatch(approve_supplier(id, token, success)),
    verify: (id, token, success) => dispatch(verify_customer(id, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(ApproveModal)
